<template>
  <!-- Left column -->
  <div v-if="isDataLoaded">
    <div class="full-width">
      <p class="card-title">
        {{ getString('module.dashboard.stats.holidays') }}
      </p>
      <div class="card-block scroll">
        <div class="row" v-for="(holiday, h) in data" :key="h">
          <div class="holiday">
            {{ formatDate(holiday.date) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'holidays',
    };
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
